import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const QalboxCustomEmailText = ({ value, onChange }) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      ["link"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }],
      ["clean"],
    ],
  };

  return (
    <div className="field">
      <label className="field-label">Email Custom Field Text</label>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        placeholder="Email Custom Field Text"
        style={{ height: "100px" }}
      />
    </div>
  );
};

export default QalboxCustomEmailText;
